module.exports = ".logout {\r\n    margin: 0 25%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.css
// module id = ./src/app/components/logout/logout.component.css
// module chunks = main